import * as React from 'react';
import CheckBox from './CheckBox';

interface ICheckboxToggleProps {
  label: string;
  children: any;
  checked?: boolean;
  onChange?: (e: any) => void;
  fieldName: string;
  values?: Array<any>;
  disabled?: boolean | ((fieldName: string, value: any, values: any) => boolean);
}

interface ICheckboxToggleState {
  isChecked: boolean;
}

class CheckboxToggle extends React.Component<ICheckboxToggleProps, ICheckboxToggleState> {

  constructor(props: ICheckboxToggleProps) {
    super(props);
    this.state = {
      isChecked: this.props.checked || false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(e: any) {
    const { fieldName, disabled, values } = this.props;

    // do not change when it's disabled
    let d = false;
    if (typeof disabled === 'function') {
      const v = values && values[fieldName];
      d = disabled(fieldName, v, values || {});
    } else {
      d = disabled || false;
    }
    
    if (d) {
      return;
    }

    this.setState({
      isChecked: !this.state.isChecked
    });

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  public componentWillReceiveProps(nextProps: ICheckboxToggleProps) {
    if (nextProps.checked !== this.state.isChecked) {
      this.setState({
        isChecked: !!nextProps.checked,
      });
    }
  }

  public render() {
    const { fieldName, label, children } = this.props;

    return (
      <div className="checkboxToggle">
        <CheckBox
          fieldName={fieldName}
          label={label}
          onChange={this.handleChange}
          checked={this.state.isChecked}
        />
        {this.state.isChecked &&
          <div className="checkboxToggle__content">
            {children}
          </div>
        }
      </div>
    );
  }
}

export default CheckboxToggle;



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/CheckboxToggle.tsx